/* ═══════════════════════════════════════════
   SYBER Auto Slideshow — Controller v4
   + Slideshow alt image
   + Pinned products (excluded from random)
   ═══════════════════════════════════════════ */
(function() {
  'use strict';

  function fillSlots(container) {
    var sectionId = container.id.replace('auto-slideshow-', '');
    var config = (window.__autoSlideshowConfig || {})[sectionId] || {};
    var showBadge = config.showBadge !== false;
    var opacity = config.accentOpacity || 1;
    var ctaText = config.ctaText || 'ORDER HERE';
    var frameStyle = config.frameStyle || 'cinematic';

    var pools = container.querySelectorAll('.auto-slideshow__pool');
    var slots = container.querySelectorAll('.auto-slideshow__slide--placeholder');
    var filledCount = 0;

    // Collect pinned product URLs to exclude from random pools
    var usedUrls = {};
    container.querySelectorAll('.auto-slideshow__slide--pinned').forEach(function(pin) {
      var url = pin.getAttribute('data-pinned-url');
      if (url) usedUrls[url] = true;
    });

    slots.forEach(function(slot) {
      var tagName = slot.getAttribute('data-tag-slot');
      var pool = container.querySelector('[data-tag-pool="' + tagName + '"]');
      if (!pool) { slot.remove(); return; }

      var candidates = Array.from(pool.querySelectorAll('.auto-slideshow__candidate'));
      if (candidates.length === 0) { slot.remove(); return; }

      // Filter out already used products (pinned + other tag slots)
      var available = candidates.filter(function(c) { return !usedUrls[c.dataset.url]; });
      if (available.length === 0) available = candidates;

      // Random pick
      var pick = available[Math.floor(Math.random() * available.length)];
      usedUrls[pick.dataset.url] = true;

      var d = pick.dataset;
      var poolData = pool.dataset;

      // Build slide HTML
      var html = '';
      html += '<img class="auto-slideshow__image" src="' + d.image + '" alt="' + d.imageAlt + '" width="1920" loading="' + (filledCount === 0 ? 'eager' : 'lazy') + '">';

      if (frameStyle === 'cinematic') {
        html += '<div class="auto-slideshow__image-overlay"></div>';
      } else {
        html += '<div class="auto-slideshow__image-overlay" style="background:linear-gradient(90deg,' + poolData.color + ' 0%,transparent 50%);"></div>';
      }

      if (showBadge) {
        html += '<div class="auto-slideshow__badge" style="background-color:' + poolData.color + ';opacity:' + opacity + ';">' + poolData.badge + '</div>';
      }

      html += '<div class="auto-slideshow__content">';
      html += '<div class="auto-slideshow__label" style="color:' + poolData.color + ';">' + poolData.label + '</div>';
      html += '<h2 class="auto-slideshow__title">' + d.title + '</h2>';
      html += '<div class="auto-slideshow__meta">';
      html += '<span class="auto-slideshow__vendor">' + d.vendor + '</span>';
      html += '<span class="auto-slideshow__price">' + d.price + '</span>';
      if (d.comparePrice) {
        html += '<span class="auto-slideshow__price-compare">' + d.comparePrice + '</span>';
      }
      html += '</div>';
      html += '<div class="auto-slideshow__buttons">';
      html += '<a href="' + d.url + '" class="auto-slideshow__cta auto-slideshow__cta--primary">' + ctaText + '</a>';
      if (poolData.listUrl && poolData.listLabel) {
        html += '<a href="' + poolData.listUrl + '" class="auto-slideshow__cta auto-slideshow__cta--secondary">' + poolData.listLabel + '</a>';
      }
      html += '</div></div>';

      slot.innerHTML = html;
      slot.classList.remove('auto-slideshow__slide--placeholder');
      filledCount++;
    });

    // Remove unfilled placeholder slots
    container.querySelectorAll('.auto-slideshow__slide--placeholder').forEach(function(s) { s.remove(); });

    // Build nav
    var allSlides = container.querySelectorAll('.auto-slideshow__slide');
    var total = allSlides.length;
    var nav = container.querySelector('.auto-slideshow__nav');
    var dotsContainer = container.querySelector('.auto-slideshow__dots');
    var emptyEl = container.querySelector('.auto-slideshow__empty');

    if (total > 1 && nav) {
      nav.style.display = '';
      dotsContainer.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'auto-slideshow__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dotsContainer.appendChild(dot);
      }
    } else if (total <= 1 && nav) {
      nav.style.display = 'none';
    }
    if (total === 0 && emptyEl) emptyEl.style.display = '';

    return total;
  }

  function AutoSlideshow(el) {
    this.el = el;
    this.track = el.querySelector('.auto-slideshow__track');
    this.current = 0;
    this.speed = parseInt(el.dataset.speed) || 7;
    this.isFade = el.classList.contains('transition-fade');
    this.autoplay = el.dataset.autoplay === 'true';
    this.paused = false;
    this.timer = null;

    this.slides = Array.from(el.querySelectorAll('.auto-slideshow__slide'));
    this.dots = Array.from(el.querySelectorAll('.auto-slideshow__dot'));
    this.prevBtn = el.querySelector('.auto-slideshow__arrow--prev');
    this.nextBtn = el.querySelector('.auto-slideshow__arrow--next');
    this.pauseBtn = el.querySelector('.auto-slideshow__pause');
    this.total = this.slides.length;

    if (this.total <= 1) return;
    this.bind();
    this.update();
    if (this.autoplay) this.startTimer();
  }

  AutoSlideshow.prototype.bind = function() {
    var self = this;
    if (this.prevBtn) this.prevBtn.addEventListener('click', function() { self.prev(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function() { self.next(); });
    if (this.pauseBtn) this.pauseBtn.addEventListener('click', function() { self.togglePause(); });
    this.dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { self.goTo(i); });
    });
    this.el.addEventListener('mouseenter', function() { if (self.autoplay && !self.paused) self.stopTimer(); });
    this.el.addEventListener('mouseleave', function() { if (self.autoplay && !self.paused) self.startTimer(); });
    var startX = 0;
    this.track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? self.next() : self.prev(); }
    }, { passive: true });
  };

  AutoSlideshow.prototype.goTo = function(index) {
    this.current = ((index % this.total) + this.total) % this.total;
    this.update();
    if (this.autoplay && !this.paused) this.resetTimer();
  };
  AutoSlideshow.prototype.next = function() { this.goTo(this.current + 1); };
  AutoSlideshow.prototype.prev = function() { this.goTo(this.current - 1); };

  AutoSlideshow.prototype.update = function() {
    var current = this.current;
    if (this.isFade) {
      this.slides.forEach(function(s, i) { s.classList.toggle('is-active', i === current); });
    } else {
      this.track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }
    this.dots.forEach(function(d, i) { d.classList.toggle('is-active', i === current); });
  };

  AutoSlideshow.prototype.startTimer = function() {
    this.stopTimer();
    var self = this;
    this.timer = setInterval(function() { self.next(); }, this.speed * 1000);
  };
  AutoSlideshow.prototype.stopTimer = function() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };
  AutoSlideshow.prototype.resetTimer = function() { this.stopTimer(); this.startTimer(); };

  AutoSlideshow.prototype.togglePause = function() {
    this.paused = !this.paused;
    if (this.paused) {
      this.stopTimer();
      if (this.pauseBtn) this.pauseBtn.textContent = '\u25B6';
    } else {
      this.startTimer();
      if (this.pauseBtn) this.pauseBtn.textContent = '\u23F8';
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.auto-slideshow').forEach(function(el) {
      fillSlots(el);
      new AutoSlideshow(el);
    });
  });
})();
